/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Title_PlaceholderInputs */

const en_job_form_title_placeholder = /** @type {(inputs: Job_Form_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Junior Software Engineer`)
};

const de_job_form_title_placeholder = /** @type {(inputs: Job_Form_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Junior Software Engineer`)
};

/**
* | output |
* | --- |
* | "e.g. Junior Software Engineer" |
*
* @param {Job_Form_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_title_placeholder = /** @type {((inputs?: Job_Form_Title_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Title_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_title_placeholder(inputs)
	return en_job_form_title_placeholder(inputs)
});